import { TableHead, TableHeader, TableRow } from '@/components/ui';
import { TableHeadSortable } from '@/components/custom';
import { ISearchUserData } from '@/lib/interface';
import { nameof } from '@/functions';

export const DataTableHeader = () => (
  <TableHeader>
    <TableRow>
      <TableHead />
      <TableHeadSortable
        className='pe-0'
        name={nameof<ISearchUserData>('accountStatus')}
        text='Status' />
      <TableHeadSortable
        className='pe-0'
        name={nameof<ISearchUserData>('countryIso3')}
        text='Pays' />
      <TableHeadSortable
        className='pe-0'
        name={nameof<ISearchUserData>('gender')}
        text='Genre' />
      <TableHead className='pe-0'>
        Age
      </TableHead>
      <TableHead className='pe-0'>
        Nom
      </TableHead>
      <TableHead className='pe-0'>
        Email
      </TableHead>
      <TableHeadSortable
        className='text-right pe-0'
        name={nameof<ISearchUserData>('coins')}
        text='Pièces' />
      <TableHeadSortable
        className='text-right pe-0'
        name={nameof<ISearchUserData>('createdAt')}
        text='Crée le' />
      <TableHead />
    </TableRow>
  </TableHeader>
);

export default DataTableHeader;
